// extracted by mini-css-extract-plugin
export default {"helpBox":"HelpBox_helpBox__IG9UW","text":"HelpBox_text__blF49","link":"HelpBox_link__VLH1g"};